import { IRoute } from "src/pages/Router/routes";
import ViewSupportTicketPage from "src/pages/Customer/Support/ViewSupportTicketPage";
import CreateSupportTicketPage from "src/pages/Customer/Support/CreateSupportTicketPage";
import { Icons } from "src/library/components/Icon/types";

import ViewSupportPageAdmin from "./ViewSupportPageAdmin";

export const AdminSupport: IRoute[] = [
  {
    exact: true,
    path: "/admin/support/tickets",
    pageComponent: ViewSupportPageAdmin,
    title: "Support Tickets",
    icon: Icons.SUPPORT,
    menuTitle: "Support",
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    roles: [ "admin" ],
    modules: [ "support" ],
    canView: ({ global }) => !!global.settings?.supportSettings?.supportTickets.enabled
  },
  {
    exact: true,
    path: "/admin/support/tickets/raise-ticket",
    pageComponent: CreateSupportTicketPage,
    title: "Raise Support Ticket",
    menuType: "ADMIN_MAIN",
    roles: [ "admin" ],
    hidden: true,
    privateRoute: true,
    canView: ({ global }) => !!global.settings?.supportSettings?.supportTickets.enabled
  },
  {
    exact: true,
    path: "/support/tickets/:supportTicketId",
    pageComponent: ViewSupportTicketPage,
    title: "Support ticket",
    menuTitle: "Support",
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    roles: [ "admin" ],
    modules: [ "support" ],
    hidden: true
  }
];

export default [ ...AdminSupport ];
